module.exports = __webpack_public_path__ + "img/zhuanshouyi.596198a2.png";